// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import moment from 'moment-timezone';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Table } from 'react-bootstrap';
import { UTC } from '../../../infrastructure/constants/common';
import Sorter from '../../utils/Sorting/Sorter';
import '../../../styles/components/PartiesList.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
import PromoListMobile from './PromoListMobile';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const PromoList = ({ promo, activeSort, handleOnClick, changeSort }) => {
  const onEditClick = event => {
    handleOnClick(event.currentTarget.getAttribute('data-promo'));
  };

  const onChangeSortClick = event => {
    changeSort(event.currentTarget.getAttribute('name'));
  };

  const getActivePeriod = item => {
    return item.startDate
      ? `${moment(item.startDate)
          .tz(UTC)
          .format('MM/DD/YY hh:mm A ')} - ${moment(item.endDate)
          .tz(UTC)
          .format('MM/DD/YY hh:mm A z')}`
      : 'none';
  };

  if (isMobileResolution()) {
    return (
      <PromoListMobile
        promo={promo}
        getActivePeriod={getActivePeriod}
        onEditClick={onEditClick}
      />
    );
  }

  return (
    <div className='partieslist'>
      <Table hover>
        <thead>
          <tr>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='name'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Code <Sorter activeSort={activeSort} name='name' />
            </th>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='startDate'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Active Period (UTC){' '}
              <Sorter activeSort={activeSort} name='startDate' />
            </th>
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              <th name='type'>Type</th>
            }
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              <th name='value'>Discount Value</th>
            }
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='status'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Status <Sorter activeSort={activeSort} name='status' />
            </th>
            <th style={{ textAlign: 'center' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {promo.map(item => (
            <tr key={item.name} data-promo={item.name}>
              <td style={{ width: '20%', verticalAlign: 'middle' }}>
                {item.name}
              </td>
              <td style={{ width: '40%', verticalAlign: 'middle' }}>
                {getActivePeriod(item)}
              </td>
              <td style={{ width: '10%', verticalAlign: 'middle' }}>
                {item.type}
              </td>
              <td style={{ width: '15%', verticalAlign: 'middle' }}>
                {item.value}
              </td>
              <td style={{ width: '10%', verticalAlign: 'middle' }}>
                {item.status}
              </td>
              <td
                style={{
                  width: '5%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  cursor: 'pointer',
                }}
              >
                <i
                  className='fas fa-pen'
                  data-promo={item.name}
                  onClick={onEditClick}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default React.memo(PromoList);
